import { render } from "./EditImage.vue?vue&type=template&id=2076273c&scoped=true"
import script from "./EditImage.vue?vue&type=script&lang=js"
export * from "./EditImage.vue?vue&type=script&lang=js"

import "./EditImage.vue?vue&type=style&index=0&id=2076273c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2076273c"]])

export default __exports__